const emailRegex =
  // eslint-disable-next-line
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
const invalidEmailError =
  "Please enter a valid email format (e.g., example@domain.com).";
const invalidPasswordError =
  "Password must contain at least eight characters, including one uppercase letter, one lowercase letter, one number, and one special character.";

export const ValidateEmail = (email) => {
  const isEmailValid = emailRegex.test(email);
  if (!isEmailValid) return invalidEmailError;
  return null;
};

export const ValidatePassword = (password) => {
  const isPassValid = passwordRegex.test(password);
  if (!isPassValid) return invalidPasswordError;
  return null;
};
